export default __webpack_public_path__ + "static/blob8-009c8c397fa8fc594abb604abf23bb11.svg";